import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EnterProjectComponent } from './enter-project/enter-project.component';
import { ProjectLandingPageComponent } from './landing-page/landing-page.component';
import { ProjectLandingPageProvider } from './landing-page/landing-page.provider';

@NgModule({
    declarations: [EnterProjectComponent, ProjectLandingPageComponent],
    imports: [CommonModule],
    exports: [EnterProjectComponent, ProjectLandingPageComponent],
    providers: [ProjectLandingPageProvider]
})
export class ProjectFeaturesModule {}
